import React from 'react';
import { Link } from 'react-router-dom';

const Brand = ({ to = '/home', compact = false }) => (
  <Link to={to} className="brand" aria-label="大黄蜂采购首页">
    <span className="brand-mark" aria-hidden="true">
      <i />
      <i />
      <i />
    </span>
    {!compact && (
      <span className="brand-name">
        大黄蜂<span>采购工作台</span>
      </span>
    )}
  </Link>
);
export default Brand;
